<template>
    <b-container>
        <div class="step-content">
            <b-row class="first-form-initial first-form-initial-4">
                <b-col cols="12" class="image-content">
                    <div class="image-finish"></div>
                </b-col>
                <b-col cols="12" class="mt-5 text-center main-title-finish text-uppercase" tabindex="0">
                   {{getMessage(24, 'congratulations-title')}}
                </b-col>
                <b-col cols="12" class="mt-4 mb-4  sub-title-initial-finish" tabindex="0">
                    {{getMessage(24, 'congratulations-sub')}}
                </b-col>
                <b-col cols="12" class="mt-1 b-5  sub-title-initial-finish" tabindex="0">
                    {{getMessage(24, 'congratulations-text')}}
                </b-col>
                <b-col cols="12" class="mt-3 b-5  sub-title-initial-finish" tabindex="0"  >
                    <ul>
                        <li><span>{{getMessage(24, 'fine')}}</span></li>
                        <br>
                        <li><span>{{getMessage(24, 'begin')}}</span></li>
                    </ul>
                </b-col>
                <b-col cols="12" class="mt-1  mb-5  sub-title-initial-finish" tabindex="0">
                    {{getMessage(24, 'Whichever')}}
                </b-col>
            </b-row>
        </div>
        <b-row :class="[isJACareerEntrepreApp ? 'icons-green-dark' : 'icons-green-light']" class="button-row">
            <b-col cols="3" class="text-center pt-1 pr-2">
                <span class="export-icon"></span>
                <br>
                <a href="javascript:void(0)" class="icon-finish-text icon-finish" role="button" @click="getPdf(true)">
                    Export
                </a>
            </b-col>
            <b-col cols="3" class="text-center pt-1 pr-2">
                <span class="print-icon"></span>
                <br>
                <a href="javascript:void(0)" class="icon-finish-text icon-finish" role="button" @click="getPdf()">
                    Print
                </a>
            </b-col>
            <b-col cols="6" class="text-center pl-2">
                <b-button role="button" class="exit-button" block variant="primary" @click="$router.push({ name: 'home' })">
                    Exit
                </b-button>
            </b-col>
        </b-row>

        <div v-if="isJACareerEntrepreApp && isGuest" class="finish-save step-content mb-3">
            <b-row class="first-form-initial first-form-initial-4 step-border">
                <b-col cols="12" class="finish-save-container">
                    <div>
                        <span class="finish-save__title">Save Project?</span>
                        <p class="finish-save__text">To guarantee that your project will be saved across different devices, log in or create an account.</p>
                    </div>
                    <div class="text-center my-4" :class="{'isCareerEntrep': isJACareerEntrepreApp}">
                        <b-button class="button-secondary" role="button" block variant="primary" @click="authenticateSSOJAUSA()">
                            Log in with JA account
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>
    import {Spinner, Project, FileUtils, Storage} from '@/core/Utils'
    import {AuthService} from '../../Security/Services'
    import validateForms from '@/core/Mixins/validate-forms'

    export default {
        name: "Finish24",
        data() {
            return {
                form: {email: "", password: ""},
                emailError: false,
                passwordError: false,
                serviceError: null,
                serviceErrorDetail: false,
                hasError: false,
                hasErrorEmailNoConfirmed: false,
            }
        },
        mixins: [validateForms],
        methods: {
            getPdf(download) {
                const user = Storage.getUser();
                const index = this.$route.params.index;
                const project = Storage.getProject(index);
                if (this.isGuest) {
                    const projectImages = Storage.getImagesByProjectId(project.projectId)
                    FileUtils.getPdfByUserGuest(project, projectImages, download, 'JABeEntrepreneurialProject.pdf')
                } else if (user.id && this.isOnline) {
                    FileUtils.getPdfByProjectUser(user.id, project.projectId, download, 'JABeEntrepreneurialProject.pdf')
                }
            },
            authenticateSSOJAUSA() {
                Spinner.start()
                AuthService.redirecToAuthorizeURL()
            },
            async login() {
                const email = this.form.email
                const password = this.form.password
                this.emailError = email === ""
                this.passwordError = password === ""
                this.hasError = false;
                this.hasErrorEmailNoConfirmed = false
                this.serviceError = null
                this.serviceErrorDetail = false

                try {
                    if (email && password && this.isValidform()) {
                        Spinner.start()
                        await AuthService.login(email, password)
                        Spinner.stop()

                        const projects = Storage.getProjects()
                        const user = Storage.getUser()

                        setTimeout(function(){
                            projects.forEach(async(project, index) => {
                                project.userId = user.id
                                await Project.syncProject(project, index, this.isOffline, false)
                            })
                        }, 2000)

                        this.offGuestHandler()
                        this.$router.push({name: 'home'})
                    }
                } catch(err) {
                    Spinner.stop()
                    this.hasError = true;
                    this.serviceError = 'Unexpected error, please try again.'
                    if (err) {
                        if (err.message && err.message === 'Email_No_Confirmed') {
                            this.serviceError = "Your email address isn't verified"
                            this.serviceErrorDetail = ''
                            this.hasErrorEmailNoConfirmed = true
                        }
                        else {
                            this.serviceError = 'Invalid email or password'
                            this.serviceErrorDetail = 'To continue, please retype your email address and password.'
                            this.hasErrorEmailNoConfirmed = false
                        }
                    }
                }
            }            
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    .container
        margin-top -5px
    .high-contrast
        ul li span
          color black
    ul li
        color: #2A93E5;
        list-style-type: disc;

    ul li span
        color: #666666;

    .image-finish
        content url("../../../core/Images/image-finish.svg")
        top 0
        bottom 0
        left 0
        right 0
        width 100%

    .step-content
        min-height calc(100vh - 50px)

    .button-row
        margin-top 44px
        padding-bottom 53px

    .image-content
        padding-top 51px

    .icon-finish-text
        margin-top 4px

    .icon-finish
        font font-poppins-semibold
        font-size 12px
        text-decoration underline
        display inline-block
        color color-4

        &:hover
            color: color-4

    .main-title-finish
        font font-poppins-bold
        font-size 24px
        color black
        line-height 1
    .sub-title-initial-finish
        margin-right 5px
        margin-left 5px
    .high-contrast
        .main-title-finish
            color black
        .icon-finish
            color black
        .sub-title-initial-finish
            color black
    +for_breakpoint(xs)
        .image-finish
            height 165px

    .step-border
        border-radius 25px !important
    .finish-save
        &-container
            padding 35px 30px

        &__title
            font font-poppins-semibold
            font-size 22px
            color color-dark
            margin-bottom 20px

        &__text
            font font-poppins-semibold
            color color-4
            font-size 16px
            line-height 25px

            &.text--black
                font font-sourcesans-regular
                font-size 16px

            &.text--green
                color color-green-light
                font font-sourcesans-regular
                font-size 16px
    .isCareerEntrep
        .btn-primary
            background-color color-green-dark
            &:hover
                background-color color-green-dark

</style>
